import { SpsIcon } from "@spscommerce/ds-shared";
import * as React from "react";

import { SpsCard, SpsMicroZeroState } from "../index";

export class SpsMicroZeroStateExample1 extends React.Component<{ 'data-testid': any }> {
    static reactLive = {
        code: `
        <SpsCard>
            <SpsMicroZeroState
                heading="Add attributes to this tag."
                icon="item-tag"
            />
        </SpsCard>
    `
    };
    render() {
        const { "data-testid": testId } = this.props;
        return (
            <SpsCard>
                <SpsMicroZeroState
                    data-testid={testId}
                    heading="Add attributes to this tag."
                    icon={SpsIcon.ITEM_TAG}
                />
            </SpsCard>
        );
    }
}

export class SpsMicroZeroStateExample2 extends React.Component<{ "data-testid": any }> {
    static reactLive = {
        code: `
        <SpsCard>
            <SpsMicroZeroState
            heading="No Document Found"
            subHeading="There are no documents associated with this transaction."
            icon="file"
            />
        </SpsCard>
        `
    };

    render() {
        const { "data-testid": testId } = this.props;
        return (
            <SpsCard>
                <SpsMicroZeroState
                    data-testid={testId}
                    heading="No Document Found"
                    subHeading="There are no documents associated with this transaction."
                    icon={SpsIcon.FILE}
                />
            </SpsCard>
        );
    }
}

